import { render, staticRenderFns } from "./UserChats.vue?vue&type=template&id=0c4c3f74&scoped=true&"
import script from "./UserChats.vue?vue&type=script&lang=js&"
export * from "./UserChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c3f74",
  null
  
)

export default component.exports